
import {Component} from './base';

export class RichTextComponent extends Component {
  public static shouldLoad() {
    return $('.richedit').length > 0;
  }

  public load() {
    const self = this;
    $('.richedit').summernote();
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/rich-text.ts